"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playDeathCrewmember = exports.playDeathAlien = exports.playCantMoveThere = exports.playShootCrewGun = exports.playShootAlienGun = exports.playEnemyShipDefeated = exports.playLoadTorpedo = exports.playFireTorpedo = exports.playFireLaser = exports.playExplosionMetalDebris = exports.playExplosionFire = exports.playExplosion = exports.playFootstep = exports.playTeleport = exports.playCompWarning2 = exports.playCompWarning1 = exports.playRepair = exports.playFireExtinguisher = exports.playFailure = exports.playSuccess = exports.playSelected = exports.playButtonClick = exports.playbuttonMouseOver = exports.playLoaded = exports.playMusicMenu = exports.playMusic1 = exports.toggleMusic = exports.toggleSounds = exports.load = exports.getMusicPath = void 0;
var log_sidecar_1 = require("@engine/log-sidecar");
var settings_sidecar_1 = require("@engine/settings-sidecar");
var soundsGeneric_sidecar_1 = require("@engine/soundsGeneric-sidecar");
var doPlayLoaded = false;
var soundTest = false;
var _musicPath = '';
function getMusicPath() {
    return _musicPath;
}
exports.getMusicPath = getMusicPath;
var logNamespace = 'sounds';
function load(audioJson, musicPath) {
    _musicPath = musicPath + '/';
    console.log('music path', _musicPath);
    soundsGeneric_sidecar_1.soundsGeneric.load(audioJson, function () {
        log_sidecar_1.log.x(logNamespace, 'loaded');
        if (doPlayLoaded) {
            playLoaded();
        }
        if (soundTest) {
            setInterval(function () {
                playLoaded();
            }, 500);
        }
    });
    playMusicMenu();
}
exports.load = load;
function toggleSounds() {
    var mute = settings_sidecar_1.settings.get().muteSound;
    settings_sidecar_1.settings.update({ muteSound: !mute, muteAmbient: !mute });
    if (!mute) {
        soundsGeneric_sidecar_1.soundsGeneric.stopAllSounds();
    }
}
exports.toggleSounds = toggleSounds;
function toggleMusic() {
    settings_sidecar_1.settings.update({ muteMusic: !settings_sidecar_1.settings.get().muteMusic });
}
exports.toggleMusic = toggleMusic;
// -- current below
// TODO: replace all of these
function playMusic1() {
    // need new!
    // soundsGeneric.playMusic(_musicPath + 'loop')
    // soundsGeneric.playMusic(_musicPath + 'theme1')
}
exports.playMusic1 = playMusic1;
function playMusicMenu() {
    // need new!
    // soundsGeneric.playMusic(_musicPath + 'theme1')
}
exports.playMusicMenu = playMusicMenu;
function playLoaded() {
    playSuccess();
}
exports.playLoaded = playLoaded;
function playbuttonMouseOver() {
    // soundsGeneric.play(_audioSprite2.AnalogButton, 0.33)
}
exports.playbuttonMouseOver = playbuttonMouseOver;
function playButtonClick() {
    // soundsGeneric.playRandom([
    //   // _audioSprite2.Button_01,
    //   _audioSprite2.Button_01_Variation_01,
    //   _audioSprite2.Button_01_Variation_02,
    //   _audioSprite2.Button_01_Variation_03,
    // ])
}
exports.playButtonClick = playButtonClick;
function playSelected() {
    //soundsGeneric.playRandom([_audioSprite2.Button_01], 0.5)
}
exports.playSelected = playSelected;
function playSuccess() {
    //soundsGeneric.playRandom([_audioSprite2.Analysis_Single_03], 0.5)
}
exports.playSuccess = playSuccess;
function playFailure() {
    //soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}
exports.playFailure = playFailure;
function playFireExtinguisher() {
    //soundsGeneric.play(_audioSprite2.fireExtingusher1, 0.25)
}
exports.playFireExtinguisher = playFireExtinguisher;
function playRepair() {
    // soundsGeneric.playRandom(
    //   [_audioSprite2.repair1, _audioSprite2.blowtorch1], //, _audioSprite2.repair2, _audioSprite2.repair3],
    //   0.75,
    // )
}
exports.playRepair = playRepair;
function playCompWarning1() {
    //soundsGeneric.playRandom([_audioSprite2.compwarn1], 0.5)
}
exports.playCompWarning1 = playCompWarning1;
function playCompWarning2() {
    //soundsGeneric.playRandom([_audioSprite2.compwarn2], 0.5)
}
exports.playCompWarning2 = playCompWarning2;
function playTeleport() {
    //soundsGeneric.playRandom([_audioSprite2.teleport1], 0.75)
}
exports.playTeleport = playTeleport;
function playFootstep() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.footMetal1,
    //     _audioSprite2.footMetal2,
    //     _audioSprite2.footMetal3,
    //     _audioSprite2.footMetal4,
    //     _audioSprite2.footMetal5,
    //     // _audioSprite2.foot1,
    //     // _audioSprite2.foot2,
    //     // _audioSprite2.foot3,
    //     // _audioSprite2.foot4,
    //   ],
    //   0.4,
    // )
}
exports.playFootstep = playFootstep;
function playExplosion() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.MediumExplosion1,
    //     _audioSprite2.MediumExplosion2,
    //     _audioSprite2.MediumExplosion3,
    //   ],
    //   0.5,
    // )
}
exports.playExplosion = playExplosion;
function playExplosionFire() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.FireExplosion7,
    //     _audioSprite2.FireExplosion8,
    //     _audioSprite2.FireExplosion9,
    //   ],
    //   0.5,
    // )
}
exports.playExplosionFire = playExplosionFire;
function playExplosionMetalDebris() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.MetalDebris1,
    //     _audioSprite2.MetalDebris2,
    //     _audioSprite2.MetalDebris3,
    //   ],
    //   0.5,
    // )
}
exports.playExplosionMetalDebris = playExplosionMetalDebris;
function playFireLaser() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.SciFiExplosion15,
    //     _audioSprite2.SciFiExplosion16,
    //     _audioSprite2.SciFiExplosion17,
    //   ],
    //   0.6,
    // )
}
exports.playFireLaser = playFireLaser;
function playFireTorpedo() {
    // soundsGeneric.playRandom(
    //   [_audioSprite2.Gun1, _audioSprite2.Gun2, _audioSprite2.Gun3],
    //   1,
    // )
}
exports.playFireTorpedo = playFireTorpedo;
function playLoadTorpedo() {
    // soundsGeneric.playRandom([_audioSprite2.gunLoad1], 0.75)
}
exports.playLoadTorpedo = playLoadTorpedo;
function playEnemyShipDefeated() {
    // soundsGeneric.playRandom([_audioSprite2.DistantBigExplosion4], 0.8)
}
exports.playEnemyShipDefeated = playEnemyShipDefeated;
function playShootAlienGun() {
    // soundsGeneric.playRandom(
    //   // [_audioSprite2.SciFiExplosion21, _audioSprite2.SciFiExplosion22],
    //   0.6,
    // )
}
exports.playShootAlienGun = playShootAlienGun;
function playShootCrewGun() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.SciFiExplosion23,
    //     _audioSprite2.SciFiExplosion24,
    //     _audioSprite2.SciFiExplosion25,
    //   ],
    //   0.6,
    // )
}
exports.playShootCrewGun = playShootCrewGun;
function playCantMoveThere() {
    // soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}
exports.playCantMoveThere = playCantMoveThere;
function playDeathAlien() {
    // soundsGeneric.playRandom(
    //   [_audioSprite2.dieAlien1, _audioSprite2.dieAlien2],
    //   0.5,
    // )
}
exports.playDeathAlien = playDeathAlien;
function playDeathCrewmember() {
    // soundsGeneric.playRandom(
    //   [
    //     _audioSprite2.diefemale1,
    //     _audioSprite2.diefemale2,
    //     _audioSprite2.diefemale3,
    //     _audioSprite2.diefemale4,
    //     _audioSprite2.diemale1,
    //     _audioSprite2.diemale2,
    //     _audioSprite2.dieMale3,
    //   ],
    //   0.5,
    // )
}
exports.playDeathCrewmember = playDeathCrewmember;
// export function play(soundName: string) {
//   soundsGeneric.play(soundName)
// }
// Links to other systems
// pubSub.on('gui:click-button', () => {
//   playButtonClick()
// })
